import apiService from '../apiService'

const apiPath = '/car'

export const carController = (configService) => {
	const service = apiService(configService)
	return {
		getAllBrands: () => {
			return service.get({
				url: `${apiPath}/get_brands_all`,
			})
		},
		getYearsByBrandID: (id_brand, typeCars) => {
			return service.get({
				url: `${apiPath}/get_year_by_id_brand?id_brand=${id_brand}&typeCar=${typeCars}`,
			})
		},
		getSeriesByYearID: (id_year, typeCars) => {
			return service.get({
				url: `${apiPath}/get_series_by_id_year?id_year=${id_year}&typeCar=${typeCars}`,
			})
		},
		getSubseriesBySeriesID: (id_series) => {
			return service.get({
				url: `${apiPath}/get_subseries_by_id_subseries?id_series=${id_series}`,
			})
		},
		findDetailCar: (params) => {
			return service.post({
				url: `${apiPath}/find_detail_car`,
				body: params,
			})
		},
		getCarType: () => {
			return service.get({
				url: `${apiPath}/get_car_type`,
			})
		},
		getAllIdCarByQuoNum: (quo_num) => {
			return service.get({
				url: `${apiPath}/get_all_id_car_by_quo_num?quo_num=${quo_num}`,
			})
		},
		getYearsByName: (brand) => {
			return service.get({
				url: `${apiPath}/get_year_by_name?brand=${brand}`,
			})
		},
		getSeriesByName: (brand, year) => {
			return service.get({
				url: `${apiPath}/get_series_by_name?brand=${brand}&year=${year}`,
			})
		},
		getSubseriesByName: (brand, year, series) => {
			return service.get({
				url: `${apiPath}/get_subseries_by_name?brand=${brand}&year=${year}&series=${series}`,
			})
		},
		getBrandAxaCmi: () => {
			return service.get({
				url: `${apiPath}/get_brand_axa_cmi`,
			})
		},
		getSeriesAxaCmi: (brand) => {
			return service.get({
				url: `${apiPath}/get_series_axa_cmi?brand=${brand}`,
			})
		},
		getSubseriesAxaCmi: (brand, series) => {
			return service.get({
				url: `${apiPath}/get_subseries_axa_cmi?brand=${brand}&series=${series}`,
			})
		},
		getBrandAxaIns: () => {
			return service.get({
				url: `${apiPath}/get_brand_axa_ins`,
			})
		},
		getYearAxaIns: (brand) => {
			return service.get({
				url: `${apiPath}/get_year_axa_ins?brand=${brand}`,
			})
		},
		getSeriesAxaIns: (brand, year) => {
			return service.get({
				url: `${apiPath}/get_series_axa_ins?brand=${brand}&year=${year}`,
			})
		},
		getSubseriesAxaIns: (brand, year, series) => {
			return service.get({
				url: `${apiPath}/get_subseries_axa_ins?brand=${brand}&year=${year}&series=${series}`,
			})
		},
		getBrandIntra: () => {
			return service.get({
				url: `${apiPath}/get_brand_intra`,
			})
		},
		getSeriesIntraByName: (brand) => {
			return service.get({
				url: `${apiPath}/get_series_intra_by_name?brand=${brand}`,
			})
		},
		getBrandIntraV2: () => {
			return service.get({
				url: `${apiPath}/get_brand_intra_v2`,
			})
		},
		getSeriesIntraByNameV2: (brand) => {
			return service.get({
				url: `${apiPath}/get_series_intra_by_name_v2?brand=${brand}`,
			})
		},
		getBrandIntraDj: () => {
			return service.get({
				url: `${apiPath}/get_brand_intra_dj`,
			})
		},
		getSeriesIntraDj: (brand) => {
			return service.get({
				url: `${apiPath}/get_series_intra_dj?brand=${brand}`,
			})
		},
		getBrandJaymart: () => {
			return service.get({
				url: `${apiPath}/get_brand_jaymart`,
			})
		},
		getSeriesJaymartByName: (brand) => {
			return service.get({
				url: `${apiPath}/get_series_jaymart_by_name?brand=${brand}`,
			})
		},
		getBrandThaisriIns: () => {
			return service.get({
				url: `${apiPath}/get_brand_thaisri_ins`,
			})
		},
		getYearThaisriIns: (brand) => {
			return service.get({
				url: `${apiPath}/get_year_thaisri_ins?brand=${brand}`,
			})
		},
		getSeriesThaisriByNameIns: (brand, year) => {
			return service.get({
				url: `${apiPath}/get_series_thaisri_by_name_ins?brand=${brand}&year=${year}`,
			})
		},
		getSubSeriesThaisriByNameIns: (brand, series, year) => {
			return service.get({
				url: `${apiPath}/get_subseries_thaisri_by_name_ins?brand=${brand}&series=${series}&year=${year}`,
			})
		},
		getBrandThaisri: () => {
			return service.get({
				url: `${apiPath}/get_brand_thaisri`,
			})
		},
		getSeriesThaisriByName: (brand) => {
			return service.get({
				url: `${apiPath}/get_series_thaisri_by_name?brand=${brand}`,
			})
		},
		getBrandDhipaya: () => {
			return service.get({
				url: `${apiPath}/get_brand_dhipaya`,
			})
		},
		getSeriesDhipayaByName: (brand) => {
			return service.get({
				url: `${apiPath}/get_series_dhipaya?brand=${brand}`,
			})
		},
		getSubSeriesDhipayaByName: (series) => {
			return service.get({
				url: `${apiPath}/get_subseries_dhipaya?series=${series}`,
			})
		},
		getBrandThaiSetakij: () => {
			return service.get({
				url: `${apiPath}/get_brand_thai_setakij`,
			})
		},
		getSeriesThaiSetakij: (brand) => {
			return service.get({
				url: `${apiPath}/get_series_thai_setakij?brand=${brand}`,
			})
		},
		getBrandKwi: () => {
			return service.get({
				url: `${apiPath}/get_brand_kwi`,
			})
		},
		getSeriesKwi: (brand) => {
			return service.get({
				url: `${apiPath}/get_series_kwi?brand=${brand}`,
			})
		},
		getBrandComdd: () => {
			return service.get({
				url: `${apiPath}/get_brand_dd`,
			})
		},
		getSeriesComdd: (brand) => {
			return service.get({
				url: `${apiPath}/get_series_dd?brand=${brand}`,
			})
		},
		getSubseriesComdd: (brand, series) => {
			return service.get({
				url: `${apiPath}/get_sub_series_dd?brand=${brand}&series=${series}`,
			})
		},
		getBrandChubb: () => {
			return service.get({
				url: `${apiPath}/get_brand_chubb`,
			})
		},
		getYearsChubb: (brand) => {
			return service.get({
				url: `${apiPath}/get_year_chubb?brand=${brand}`,
			})
		},
		getSeriesChubb: (brand, year) => {
			return service.get({
				url: `${apiPath}/get_series_chubb?brand=${brand}&year=${year}`,
			})
		},
		getBrandRVP: () => {
			return service.get({
				url: `${apiPath}/get_brand_rvp`,
			})
		},
		getBrandViriyaIns: () => {
			return service.get({
				url: `${apiPath}/get_brand_viriya`,
			})
		},
		getYearViriyaIns: (brand) => {
			return service.get({
				url: `${apiPath}/get_year_viriya?brand=${brand}`,
			})
		},
		getSeriesViriyaIns: (brand) => {
			return service.get({
				url: `${apiPath}/get_series_viriya?brand=${brand}`,
			})
		},
		getSubseriesViriyaIns: (brand, series) => {
			return service.get({
				url: `${apiPath}/get_sub_series_viriya?brand=${brand}&series=${series}`,
			})
		},
		getBrandFci: () => {
			return service.get({
				url: `${apiPath}/get_brand_fci`,
			})
		},
		getSeriesFci: (brand) => {
			return service.get({
				url: `${apiPath}/get_series_fci?brand=${brand}`,
			})
		},
		getBrandFciIns: () => {
			return service.get({
				url: `${apiPath}/get_brand_fci_ins`,
			})
		},
		getYearFciIns: (brand) => {
			return service.get({
				url: `${apiPath}/get_year_fci_ins?brand=${brand}`,
			})
		},
		getSeriesFciIns: (brand, year) => {
			return service.get({
				url: `${apiPath}/get_series_fci_ins?brand=${brand}&year=${year}`,
			})
		},
		getSubseriesFciIns: (brand, year, series) => {
			return service.get({
				url: `${apiPath}/get_subseries_fci_ins?brand=${brand}&year=${year}&series=${series}`,
			})
		},
		getBrandTpb: () => {
			return service.get({
				url: `${apiPath}/get_brand_tpb`,
			})
		},
		getSeriesTpb: (brand) => {
			return service.get({
				url: `${apiPath}/get_series_tpb?brand=${brand}`,
			})
		},
		getBrandViriyaV2: () => {
			return service.get({
				url: `${apiPath}/get_brand_viriya_v2`,
			})
		},
		getYearViriyaV2: (brand) => {
			return service.get({
				url: `${apiPath}/get_year_viriya_v2?brand=${brand}`,
			})
		},
		getSeriesViriyaV2: (brand, year) => {
			return service.get({
				url: `${apiPath}/get_series_viriya_v2?brand=${brand}&year=${year}`,
			})
		},
		getSubSeriesViriyaV2: (brand, year, series) => {
			return service.get({
				url: `${apiPath}/get_sub_series_viriya_v2?brand=${brand}&series=${series}&year=${year}`,
			})
		},
		getBrandViriyaCmi: () => {
			return service.get({
				url: `${apiPath}/get_brand_viriya_cmi`,
			})
		},
		getSeriesViriyaCmi: (brand) => {
			return service.get({
				url: `${apiPath}/get_series_viriya_cmi?brand=${brand}`,
			})
		},
		getSubSeriesViriyaCmi: (brand, series) => {
			return service.get({
				url: `${apiPath}/get_sub_series_viriya_cmi?brand=${brand}&series=${series}`,
			})
		},
		getBrandDvsCmi: () => {
			return service.get({
				url: `${apiPath}/get_brand_dvs_cmi`,
			})
		},
		getSeriesDvsCmi: (brand) => {
			return service.get({
				url: `${apiPath}/get_series_dvs_cmi?brand=${brand}`,
			})
		},
		getSubSeriesDvsCmi: (brand, series) => {
			return service.get({
				url: `${apiPath}/get_sub_series_dvs_cmi?brand=${brand}&series=${series}`,
			})
		},
		getBrandDvsIns: () => {
			return service.get({
				url: `${apiPath}/get_brand_dvs_ins`,
			})
		},
		getSeriesDvsIns: (brand) => {
			return service.get({
				url: `${apiPath}/get_series_dvs_ins?brand=${brand}`,
			})
		},
		getSubSeriesDvsIns: (brand, series) => {
			return service.get({
				url: `${apiPath}/get_sub_series_Dvs_ins?brand=${brand}&series=${series}`,
			})
		},
	}
}
